import { jsonName } from "../../decorators/json-name";
import { TxnType } from "../../types";
import { TransactionRequest } from "../transaction-request";

export class RefundRequest extends TransactionRequest {
  constructor(input: { AmountPurchase: number }) {
    super();
    this.AmountPurchase = input.AmountPurchase;
  }

  TxnType = TxnType.Refund;

  // The purchase amount (in cents) of the transaction.
  @jsonName("AmtPurchase")
  AmountPurchase: number;
}
